import CreateGameLoading from "@/shared/ui/loading/CreateGameLoading"
import CustomsLoading from "@/shared/ui/loading/CustomsLoading"
import FriendsLoading from "@/shared/ui/loading/FriendsLoading"
import GameLoading from "@/shared/ui/loading/GameLoading"
import HomeLoading from "@/shared/ui/loading/HomeLoading"
import ProfileLoading from "@/shared/ui/loading/ProfileLoading"
import QuestsLoading from "@/shared/ui/loading/QuestsLoading"
import TopLoading from "@/shared/ui/loading/TopLoading"
import { ComponentType, lazy, ReactNode, Suspense } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import Layout from "../layout"

const CreateGamePage = lazy(() => import("@/pages/CreateGame"))
const MainPage = lazy(() => import("@/pages/Main"))
const GameWrapper = lazy(() => import("@/pages/Game"))
const QuestsPage = lazy(() => import("@/pages/Quests"))
const CustomsPage = lazy(() => import("@/pages/Customs"))
const ProfilePage = lazy(() => import("@/pages/Profile"))
const LeaderboardPage = lazy(() => import("@/pages/Leaderboard"))
const FriendsPage = lazy(() => import("@/pages/Friends"))

interface RouteConfig {
  Component: ComponentType
  icon?: ReactNode
  path: string
  title?: string
  loader?: ReactNode
}

const routes: RouteConfig[] = [
  { path: "/create", Component: CreateGamePage, loader: <CreateGameLoading /> },
  {
    path: "/game",
    Component: GameWrapper,
    loader: <GameLoading />,
  },
]

const menuRoutes: RouteConfig[] = [
  { path: "quests", Component: QuestsPage, loader: <QuestsLoading /> },
  { path: "profile", Component: ProfilePage, loader: <ProfileLoading /> },
  {
    path: "leaderboard",
    Component: LeaderboardPage,
    loader: <TopLoading />,
  },
  { path: "friends", Component: FriendsPage, loader: <FriendsLoading /> },
  { path: "customs", Component: CustomsPage, loader: <CustomsLoading /> },
]

export const RouterProvider = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route
          index
          element={
            <Suspense fallback={<HomeLoading />}>
              <MainPage />
            </Suspense>
          }
        />
        {menuRoutes.map(({ path, Component, loader }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={loader}>
                <Component />
              </Suspense>
            }
          />
        ))}
      </Route>
      {routes.map(({ path, Component, loader }) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={loader}>
              <Component />
            </Suspense>
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
